import { render, staticRenderFns } from "./OAuthUnauthorized.vue?vue&type=template&id=55de5fc6&scoped=true"
import script from "./OAuthUnauthorized.vue?vue&type=script&lang=js"
export * from "./OAuthUnauthorized.vue?vue&type=script&lang=js"
import style0 from "./OAuthUnauthorized.vue?vue&type=style&index=0&id=55de5fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de5fc6",
  null
  
)

export default component.exports